import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { brandStyles, clientUrl, drawDate, logoNode, money } from './V2Helpers'
import CheckTickets from '../../containers/CheckTicketsContainer'

class V2PastEvents extends Component {
    state = {
        events: null,
        showCheckTickets: false,
        selectedEvent: null
    }

    componentDidMount() {
        this.loadEvents()
    }

    loadEvents() {
        this.props.fetchPastEvents(this.props.client.stub, (events) => {
            this.setState({ events: events || [] })
        })
    }

    render() {
        const { client, event } = this.props
        const brand = brandStyles(client, event)
        const backgroundStyle = {
            backgroundImage: brand.backgroundUrl ? "url(" + brand.backgroundUrl + ")" : undefined,
            "--v2-primary": brand.primaryColor,
            "--v2-secondary": brand.secondaryColor
        }
        const overlayStyle = { backgroundColor: brand.overlayColor, opacity: brand.overlayOpacity }
        const events = this.state.events

        return (
            <div className="v2-public-page v2-past-page" style={backgroundStyle}>
                <div className="v2-public-overlay" style={overlayStyle} />
                <CheckTickets
                    v2
                    show={this.state.showCheckTickets}
                    onHide={() => this.setState({ showCheckTickets: false })}
                    eventId={this.state.selectedEvent && this.state.selectedEvent.eventId}
                    eventSource={this.state.selectedEvent && this.state.selectedEvent.source}
                    clientUrl={clientUrl(client)}
                    winningTicketId={this.state.selectedEvent && this.state.selectedEvent.winningTicket} />
                <main className="v2-past-content">
                    {logoNode(client, event, "v2-public-logo")}
                    <h1>Past events</h1>
                    {!events ? <p>Loading events...</p> : null}
                    {events && events.length === 0 ? <p>No previous events found.</p> : null}
                    {events && events.length ? (
                        <div className="v2-past-list">
                            {events.map((item) => (
                                <article key={item.eventId} className="v2-past-card">
                                    <div>
                                        <h2>{item.name || item.title}</h2>
                                        <p>{drawDate(item.completedAt || item.drawDate)}</p>
                                    </div>
                                    <strong>{money(item.prizePool)}</strong>
                                    <button onClick={() => this.setState({ selectedEvent: item, showCheckTickets: true })}>Check my ticket</button>
                                </article>
                            ))}
                        </div>
                    ) : null}
                    <button className="v2-secondary-solid" onClick={() => this.props.history.push("/" + clientUrl(client))}>Back to event</button>
                </main>
            </div>
        )
    }
}

export default withRouter(V2PastEvents)
